import axios, { AxiosResponse } from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useMemo } from "react";
import { v4 as uuid } from "uuid";
import { toast } from "react-toastify";
import { AuthContext } from "../contexts/AuthContext/AuthContext";
import { saveByteArray } from "../helper/saveByteArray";
import { useCookies } from "react-cookie";

export function useAxios(showError = true) {
  const navigate = useNavigate();
  const { isAuthenticated, signOut } = useContext(AuthContext);
  const location = useLocation();
  const [cookies] = useCookies(["APPLICATION_MODE", "ACCESS_TOKEN", "BUSINESS_ID"]);
  var client = useMemo(() => {
    const instance = axios.create({
      baseURL: (window as any).BASE_URL + "/" + (cookies.APPLICATION_MODE ?? "live"),
    });

    instance.defaults.headers.post["Content-Type"] = "application/json";

    if (isAuthenticated) {
      var accessToken = cookies.ACCESS_TOKEN;
      if (accessToken) {
        instance.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
      }
    }

    var businessId = cookies.BUSINESS_ID;
    if (businessId) {
      instance.defaults.headers.common["businessId"] = businessId;
    }

    instance.interceptors.response.use(
      (response: any) => {
        if (response.headers["content-type"] === "application/octet-stream") {
          saveByteArray(`${uuid()}.csv`, response.data);
        }

        return Promise.resolve(response.data);
      },
      (error: any) => {
        const response: AxiosResponse<any, any> | undefined = error.response;
        if (!response) {
          console.log("Error occurred. Pleae check your internet and try again.");
        }

        if (response?.status === 404 && showError) {
          navigate("/not-found", { replace: true });
        }
        if (response?.status === 500 && showError) {
          // toast.error("Server error. Please try again.");
          navigate("/server-error");
        }

        if (response?.status === 401 || response?.status === 403) {
          signOut();
          navigate("/login", { state: location });
        }
        if (response?.status === 429) {
          toast.warning(response?.data?.message);
        }
        if (response?.status === 400 && showError) {
          toast.error(response.data.message);
        }

        return Promise.reject(response?.data);
      }
    );
    return instance;
  }, [isAuthenticated, cookies.APPLICATION_MODE]);

  return client;
}
declare var grecaptcha;
export const getCaptchaToken = async () => await grecaptcha.execute("6LfYyqMeAAAAABFUITEKEuPYScAwgCS_v4ld_8DI", { action: "submit" });
